module.exports = __webpack_public_path__ + "img/careers_cv_ricevuti.840be71a.png";